import * as Yup from 'yup'

const AddProject = Yup.object().shape({
  name: Yup.string().required('Please enter project name'),
  orgId: Yup.number().required('Please select an organization'),
})

// eslint-disable-next-line import/no-anonymous-default-export
export default { AddProject }
